import React, { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { MdOutlineClose, MdOutlineCheck, MdOutlineRefresh, MdOutlineSearch } from "react-icons/md";
import { Input, Button } from "react-daisyui"
import { useBadWordStore, BadWordStore, BadWordStoreContext } from "../store/BadWordStore";
import { observer } from "mobx-react";
import { useAuthStore } from "../../Auth/store/Auth";

// const Filter = observer(() => {
//     const store = new BadWordStore({
//         isloading:true,
//       });
//     return (
//         <BadWordStoreContext.Provider value={store}>
//             <Screen />
//         </BadWordStoreContext.Provider>
//     )
// })

// export default Filter;

const Filter = observer(({emptyinput}) => {
    const [searchParams] = useSearchParams();
    const searchParamPage = 1;
    const {Token} = useAuthStore();
    const { 
        setScreen,
        setstatus,
        getBadWords,
        getFilterBadWord,
        NofilterwithPagination,
        loadTableData,
        setfiltertrue,
        Producttypelist,
        Screen,
        setname,
        name
      } = useBadWordStore();

      const Reset=()=>{
        setname("")
        setstatus("")
        getBadWords(searchParamPage || 1,Token)
        setfiltertrue(false);
    }


    useEffect(() => {
        setname("")
        setstatus("")
    },[emptyinput])

    const handleChange = (e) => {
        // Get the value from the input
        const value = e.target.value;

        // Trim both leading and trailing spaces
        const trimmedValue = value.trimStart();

        // Prevent setting the value if it's just spaces or empty
        if (trimmedValue === "") {
            setname(""); // Clear the state if the value is just spaces or empty
            return;
        }

        setname(trimmedValue); // Set the state with the trimmed value
    };

    return (
        <>

            <div className="card bg-base-100 shadow-md p-6 mt-3 mb-10">
                <form onSubmit={(e) => {NofilterwithPagination(false);getFilterBadWord(searchParamPage || 1,Token);e.preventDefault() }}>
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 md:gap-8 gap-4">
                        <div>
                            <label htmlFor="Screen" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">NSFW Word</label>
                            <Input
                                name="name"
                                placeholder="NSFW Word"
                                onChange={handleChange}
                                id="name"
                                value={name}
                                type="text"
                                autoComplete="off"
                                className="focus:outline-0 w-full text-sm font-medium rounded-md"
                            />
                        </div>
                        {/* <div>
                            <label htmlFor="keywords" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Keywords</label>
                            <Input
                                name="keywords"
                                placeholder="keywords"
                                id="keywords"
                                type="text"
                                autoComplete="off"
                                className="focus:outline-0 w-full text-sm font-medium rounded-md"
                            />
                        </div> */}
                    </div>
                    <div className="lg:mt-3 mt-4 flex items-center md:justify-end justify-between">
                        <button type="reset" onClick={() => { Reset()  }} className="btn btn-md bg-darkgreen text-[#fff] text-sm hover:text-darkgreen hover:bg-lightgreen "><MdOutlineRefresh className="mr-1" />Reset</button>
                        <button type="submit" className="btn btn-md bg-lightgreen text-darkgreen text-sm hover:bg-darkgreen hover:text-[#fff]   ml-4"><MdOutlineSearch className="mr-1" />Search</button>
                    </div>
                </form>
            </div>

        </>
    )
})

export default Filter;
